/**
* User management & login
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('member.info.profil.edit', {
            url: '/' + urls.edit.fr, // TODO : when multilang, change this to something dynamic
            views: {
                'profil@member.info.profil': {
                    controller: ['$scope', '$state', 'profile', '$filter', '$document', function ($scope, $state, $profile, $filter, $document) {

                        // form handler
                        $scope.userForm = {
                            pending: false
                        };
                        $scope.user = {
                            login: $scope.member.mail,
                            login_confirmation: $scope.member.mail,
                            pass: '',
                            pass_old: '',
                            pass_confirmation: ''
                        };

                        // cancel action
                        $scope.cancel = function () {
                            if (!$scope.userForm.pending) {
                                $scope.userForm.pending = true;
                                $state.go('member.info.profil');
                            }
                        };

                        $scope.scrolltoForm = function () {
                            var element = angular.element(document.getElementById('memberForm'));
                            $document.scrollToElement(element, 30, 250);
                        };

                        // registering modifications
                        $scope.update = function () {
                            $scope.userForm.pending = true;
                            if ($scope.userForm.$valid) {
                                $profile.amend($scope.user).then(function () {
                                    $scope.userForm.pending = false;
                                    $state.go('member.info.profil', { message: $filter('translate')('account.hasBeenUpdated') });
                                }).catch(function (error) {
                                    $scope.userForm.pending = false;
                                    $scope.scrolltoForm();
                                });
                            } else {
                                $scope.userForm.pending = false;
                                $scope.scrolltoForm();
                            }
                        };

                    }],
                    // templateUrl: 'src/views/member/member_info_profil.html'
                    templateUrl: 'src/views/member/member_info_profil_edit.html'
                },
                'coordinate@member.info.profil': {
                    templateUrl: 'src/views/member/member_info_coordinate.html'
                }
            }
        })
        .state('member.info.profil.editcoordinate', {
            url: '/' + urls.member.coordinates.fr, // TODO : when multilang, change this to something dynamic
            views: {
                'profil@member.info.profil': {
                    templateUrl: 'src/views/member/member_info_profil.html'
                },
                'coordinate@member.info.profil': {
                    controller: ['$rootScope', '$scope', 'profile', 'tools', '$state', '$filter', 'moment', '$document',"formPattern", "utils", function ($rootScope, $scope, $profile, tools, $state, $filter, moment, $document, formPattern, utils) {
                        $scope.tools = tools;
                        $scope.formPattern = formPattern;

                        // form handler
                        $scope.userForm = {
                            pending: false
                        };
                        $scope.genderLabels = [
                            { text: $filter('translate')('form.male'), value: 'M.' }, { text: $filter('translate')('form.female'), value: 'Mme' }
                        ];
                        $scope.dateRegex = new RegExp("^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$");

                        $scope.config = $rootScope.config;

                        $scope.user = {
                            num: $scope.member.field_num_adherent,
                            civility: $scope.member.field_civilite,
                            firstname: $scope.member.field_prenom,
                            lastname: $scope.member.field_nom,
                            birth_date: $filter('date')(new Date($scope.member.field_date_de_naissance), 'shortDate'),
                            nationality: $scope.member.field_nationalite,
                            mobile: $scope.member.field_tel_portable ? $scope.member.field_tel_portable.replaceAll(" ", "") : '',
                            phone: $scope.member.field_tel_fixe ? $scope.member.field_tel_fixe.replaceAll(" ", "") : '',
                            address: $scope.member.field_adresse,
                            complement: $scope.member.field_comp_adresse,
                            postal_code: $scope.member.field_cp ? $scope.member.field_cp : '',
                            city: $scope.member.field_ville,
                            country: $scope.member.field_pays,
                            newsletter_commercial: $scope.member.field_newsletter_partenaires === '1',
                            newsletter_official: $scope.member.field_newsletter_glenans === '1'
                        };

                        // legal guardian
                        if (!$scope.member.field_tuteur_legal) {
                            $scope.member.field_tuteur_legal = {};
                        }
                        $scope.user.primaryContact = {
                            civility: $scope.member.field_tuteur_legal.field_civilite,
                            firstname: $scope.member.field_tuteur_legal.field_prenom,
                            lastname: $scope.member.field_tuteur_legal.field_nom,
                            birth_date: $scope.member.field_tuteur_legal.field_date_de_naissance ? $filter('date')(new Date($scope.member.field_tuteur_legal.field_date_de_naissance), 'shortDate') : '',
                            phone: $scope.member.field_tuteur_legal.field_tel_fixe,
                            email: $scope.member.field_tuteur_legal.name
                        };
                        // secondary contact
                        if (!$scope.member.field_autre_personne) {
                            $scope.member.field_autre_personne = {};
                        }
                        $scope.user.secondaryContact = {
                            civility: $scope.member.field_autre_personne.field_civilite,
                            firstname: $scope.member.field_autre_personne.field_prenom,
                            lastname: $scope.member.field_autre_personne.field_nom,
                            birth_date: $scope.member.field_autre_personne.field_date_de_naissance ? $filter('date')(new Date($scope.member.field_autre_personne.field_date_de_naissance), 'shortDate') : '',
                            phone: $scope.member.field_autre_personne.field_tel_fixe,
                            email: $scope.member.field_autre_personne.name
                        };

                        // google places handler
                        $scope.$watchCollection('userForm.search_address', function (value) {
                            if (value && value.address_components) {
                                var formated = tools.formatGAddress(value);
                                if (formated.address) {
                                    $scope.user.address = formated.address;
                                    $scope.user.postal_code = formated.postal_code;
                                    $scope.user.city = formated.city;
                                    $scope.user.country = formated.country;
                                }
                            }
                        });

                        // cancel action
                        $scope.cancel = function () {
                            if (!$scope.userForm.pending) {
                                $scope.userForm.pending = true;
                                $state.go('member.info.profil');
                            }
                        };

                        $scope.scrolltoForm = function () {
                            var element = angular.element(document.getElementById('memberForm'));
                            $document.scrollToElement(element, 30, 250);
                        };

                        // registering modifications
                        $scope.update = function () {
                            $scope.userForm.pending = true;
                            if ($scope.userForm.$valid) {

                                var data = angular.copy($scope.user);
                                data.birth_date = moment($scope.user.birth_date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");

                                if (data.primaryContact && data.primaryContact.birth_date) {
                                    data.primaryContact.birth_date = moment(data.primaryContact.birth_date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                                }

                                if (data.secondaryContact && data.secondaryContact.birth_date) {
                                    data.secondaryContact.birth_date = moment(data.secondaryContact.birth_date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                                }

                                $profile.amend(data).then(function () {
                                    $scope.userForm.pending = false;
                                    // remove warning panel if needed
                                    if ($scope.teaserPanel.type === 'warning') {
                                        angular.merge($scope.teaserPanel, { css: null, body: null });
                                    }
                                    $state.go('member.info.profil', { message: $filter('translate')('account.hasBeenUpdated') });
                                }).catch(function (error) {
                                    $scope.userForm.pending = false;
                                    $scope.scrolltoForm();
                                });
                            } else {
                                $scope.userForm.pending = false;
                                $scope.scrolltoForm();
                            }
                        };

                        utils.calendarTrad()
                        $scope.initDatepicker = function(){
                            utils.calendarTrad()
                        }
                    }],
                    templateUrl: 'src/views/member/member_info_coordinate_edit.html'
                }
            }
        });

}]);
